import { useLayoutEffect, useRef, useState } from 'react';

/**
 * Returns a ref to attach to the wrapper element and the nearest `[role="dialog"]`
 * ancestor (if any) to use as a Radix portal container.
 *
 * Portalling into the dialog keeps Radix FocusScope from stealing focus away from
 * inputs rendered inside popovers/calendars that are mounted inside a dialog.
 * Outside a dialog, `portalContainer` stays `undefined` (portals to body).
 */
export function useDialogPortalContainer<T extends HTMLElement = HTMLElement>() {
  const wrapperRef = useRef<T | null>(null);
  const [portalContainer, setPortalContainer] = useState<HTMLElement | undefined>(undefined);

  useLayoutEffect(() => {
    const dialog = wrapperRef.current?.closest<HTMLElement>('[role="dialog"]');
    if (dialog) setPortalContainer(dialog);
  }, []);

  return { wrapperRef, portalContainer };
}
